import { FEATURED_BRANDS_PATH } from '@libs/algolia';

export const FEATURED_SHOPS_PATH = 'featured-shops';
export const FEATURED_PAGE_PATHS = [FEATURED_BRANDS_PATH, FEATURED_SHOPS_PATH];
